export enum FormFieldTypes {
    YesNo = 1,
    TwoValues = 2,
    FreeText = 3,
    Rating = 4,
    Options = 5,
    Search = 6,
    OneValue = 7,
    Legend = 8,
    DynamicKeyValue = 9,
    Images = 10,
    RadioButton = 11,
    CheckBoxList = 12,
}